import { ApolloLink } from '@apollo/client';
import type { Operation, NextLink } from '@apollo/client';
import analytics from 'modules/analytics';

/**
 * Adds x-read-session header with analytics.readSession
 * so the server can attach it to Datadog context.
 */
export const readSessionLink = new ApolloLink((operation: Operation, forward: NextLink) => {
  const readSession = analytics.readSession;

  operation.setContext(({ headers = {} }) => ({
    headers: {
      ...headers,
      'x-read-session': readSession != null ? JSON.stringify(readSession) : null,
    },
  }));

  return forward(operation);
});
